module.exports = __webpack_public_path__ + "img/31n.eed127b7.png";